import { ActionModal } from '@desquared/wave-components-library';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';
import React from 'react';
import { getLayoutProps } from '@/utils/layout/layout';
import PageLayout from '@/components/PageLayout';
import Head from 'next/head';

import styles from '@/styles/Order.module.css';

export default function CheckoutError({ responsiveLogo, imageUrl }) {
  const t = useTranslations('common.home');
  const router = useRouter();

  return (
    <>
      <Head>
        <title>{process.env.displayName}</title>
        <meta name="description" content={`App for ${process.env.displayName} by Wave Grocery`} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href={responsiveLogo} />
      </Head>

      <main>
        <section className={styles.container}>
          <div className={styles.content}>
            <ActionModal
              title={t('order_cancel_title')}
              text={t('order_cancel_description')}
              actions={[
                {
                  btnLabel: t('return'),
                  onClick: () => {
                    close();
                    router.push('/checkout');
                  },
                },
              ]}
              img={{
                url: imageUrl,
                ariaLabel: t('order_cancel_title'),
                size: 'medium',
              }}
            />
          </div>
        </section>
      </main>
    </>
  );
}

CheckoutError.getLayout = function getLayout(page) {
  return <PageLayout>{page}</PageLayout>;
};

export async function getStaticProps(context) {
  const layoutProps = await getLayoutProps({ headerProps: { selectedIndex: -1 } }, context.locale);

  const imageUrl = layoutProps?.emptyStates?.cancel_order_empty_state?.url
    ? layoutProps?.emptyStates?.cancel_order_empty_state?.url
    : '/assets/wave-grocery/BananaWorried.png';

  const messages = {
    common: (await import(`../../../prebuild-data/i18n/${context.locale}/common.json`)).default,
  };

  return {
    props: {
      ...layoutProps,
      imageUrl,
      messages,
    },
  };
}
